export var buildEnv = {
    buildMode: 'release',
    datacenter: 'us',
    sdkVersion: '2.7.1',
};
//# sourceMappingURL=buildEnv.js.map